import React from 'react';
import FallbackImage from 'assets/images/generated-content-fallback-image.png';
import { colors } from '@insurancemenu/imenu-components-lib';
import { ArrowBack } from '@insurancemenu/imenu-components-lib/dist/icons';
import {
  FallbackTitleStyled,
  GeneratedContentFallbackStyled,
  FallbackMessageStyled,
  TextSectionStyled,
  FallbackImageStyled,
  FallbackExplanation,
  ActionBlock,
  ActionButton,
  ContentSectionStyled,
} from './styles';
import {
  FALLBACK_GO_BACK_BTN_TEST_ID,
  FALLBACK_RELOAD_BTN_TEST_ID,
  GENERATED_CONTENT_FALLBACK_TEST_ID,
} from '../constants';

export interface GeneratedContentFallbackProps {
  isError: boolean;
  contentName: string;
  children: React.ReactNode;
  onGoBack: () => void;
  sectionTestId?: string;
}

const GeneratedContentFallback: React.FC<GeneratedContentFallbackProps> = ({
  isError,
  contentName,
  children,
  onGoBack,
  sectionTestId,
}) => {
  function reloadPage(): void {
    window.location.reload();
  }

  return isError ? (
    <GeneratedContentFallbackStyled data-test-id={GENERATED_CONTENT_FALLBACK_TEST_ID} data-test-for={sectionTestId}>
      <ContentSectionStyled>
        <TextSectionStyled>
          <FallbackTitleStyled>Oops!</FallbackTitleStyled>
          <FallbackMessageStyled>The {contentName} is taking a while to generate...</FallbackMessageStyled>
          <FallbackExplanation>
            It seems like your request needs a bit more time to be processed by our servers. Please, reload the page or
            come back later.
          </FallbackExplanation>
        </TextSectionStyled>
        <ActionBlock>
          <ActionButton
            type="outlined"
            leftIconProp={<ArrowBack />}
            size="large"
            onClick={onGoBack}
            data-test-id={FALLBACK_GO_BACK_BTN_TEST_ID}
          >
            Go Back
          </ActionButton>
          <ActionButton
            color="custom"
            customColor={colors.orange[600]}
            size="large"
            onClick={reloadPage}
            data-test-id={FALLBACK_RELOAD_BTN_TEST_ID}
          >
            Reload
          </ActionButton>
        </ActionBlock>
      </ContentSectionStyled>
      <FallbackImageStyled
        src={FallbackImage as string}
        height="auto"
        width="450"
        alt="Illustrative image showing that the content was not loaded."
      />
    </GeneratedContentFallbackStyled>
  ) : (
    children
  );
};

export default GeneratedContentFallback;
